import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { IMember } from 'src/app/interfaces/member';
import { ApiService } from 'src/app/services/api.service';
import { Subscription as RxSubscription } from 'rxjs';

import { IMemberOrderConfig } from '../../../interfaces/member-order-config';
import { IMembership } from '../../../interfaces/membership';
import { OrganisationMemberApiService } from '../../../services/organisation-member-api-service';

@Component({
    selector: 'organisation-member-orders-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class OrganisationsMemberOrders implements OnInit, OnDestroy {
  public loading = false;
  public Member: IMember;
  public Memberships: IMembership[];
  private Subscriptions: RxSubscription[] = [];

  constructor(
    protected OrganisationMemberApi: OrganisationMemberApiService,
    protected Api: ApiService,
    @Inject(MAT_DIALOG_DATA) private data: IMemberOrderConfig
  ) {}

  ngOnInit() {
    this.Member = this.data.Member;
    this.load();
  }

  public load() {
    const organisationId = this.data.organisationId;

    let endpoint = `organisation-admin/organisation-id/${organisationId}/member/${this.Member.id}`;

    this.Api.get(endpoint).then(
      (Memberships: IMembership[]) => (this.Memberships = Memberships),
      (error) => this.Api.handleError(error)
    );
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
